import { render, staticRenderFns } from "./DeleteImageModal.vue?vue&type=template&id=881ad254&"
import script from "./DeleteImageModal.vue?vue&type=script&lang=js&"
export * from "./DeleteImageModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports